module.exports = __webpack_public_path__ + "static/media/logo188.f71bc28e.png";